define(
    'SuiteDynamics.CategoryFAQ.EntryPoint',
    [
        'SuiteDynamics.CategoryFAQ.View',
        'SuiteDynamics.CategoryFAQ.SS2Model'
    ],
    function (
        CategoryFAQView,
        CategoryFAQModel
    ) {
        'use strict';

        return {
            mountToApp: function (container) {
                var plp = container.getComponent('PLP');
                if (!plp) {
                    return;
                }

                var categoryFaqData = [];

                plp.on('beforeShowContent', function () {
                    var model = new CategoryFAQModel();
                    var dfd = jQuery.Deferred();

                    var categoryInfo = plp.getCategoryInfo();
                    var currentCategoryId = Number(categoryInfo.internalid);

                    // console.log('PLP CATEGORY ID', currentCategoryId);

                    model.fetch({
                        data: {
                            categoryId: currentCategoryId
                        }
                    }).done(function (data) {
                        var faqs = data.faqs || data || [];

                        // console.log('FAQ RAW DATA', faqs);

                        categoryFaqData = faqs.filter(function (faq) {
                            var faqCategoryId = Number(
                                faq.categoryIdFaq ||
                                (faq.category && faq.category.value)
                            );
                            return faqCategoryId === currentCategoryId;
                        }).sort(function (a, b) {
                                return Number(a.sort || 0) - Number(b.sort || 0);
                            });

                    // console.log('FAQ FILTERED DATA', categoryFaqData);

                    }).always(function () {
                        dfd.resolve();
                    });

                    return dfd;
                });

                plp.addChildView(
                    'Facets.Browse.CategoryFaq',
                    function () {
                        return new CategoryFAQView({
                            container: container,
                            getFaqs: function () {
                                return categoryFaqData;
                            }
                        });
                    }
                );
            }
        };
    }
);
